import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">用户口碑</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">来自真实用户对神马视频91在线视频、97视频、51视频的评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 text-sm font-semibold">{comment.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-0.5 mt-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}